import React from "react"
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { Box, Typography } from "@mui/material"
import { dsColorNew } from "@palette"


export default function AlertsComparatorUnit() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparatorUnit || 0)

	const labelsFormatted = {
		0: { icon: "money-bills", label: "Currency", color: dsColorNew.successText },
		1: { icon: "percentage", label: "Percentage", color: "none" },
	}

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		disableClearable
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_unit`}
		label="Select unit"
		inputProps={{
			startAdornment: <IconSeeker
				icon={labelsFormatted[dataInfo.value].icon}
				sx={{
					color: labelsFormatted[dataInfo.value].color,
					ml: 1,
					mr: .5
				}}
			/>
		}}
		onAjax={options => {
			return options.map(({ value }) => ({
				value: value,
				label: labelsFormatted[value].label,
			}))
		}}
		formatOptionLabel={({ value }) => {
			return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
				<IconSeeker
					icon={labelsFormatted[value].icon}
					sx={{ color: labelsFormatted[value].color }}
				/>
				<Typography>{labelsFormatted[value].label}</Typography>
			</Box>
		}}
		placeholder="Unit used on comparison"
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparatorUnit')}
	/>
}
